import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import 'antd/dist/antd.css'
import { isMobile, isTablet } from 'react-device-detect'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'
import { Col, Layout, Row } from 'antd'
import _refiner from 'refiner-js'
import { isMobileAction } from 'redux/device/device.action'
// import { clientPublic } from 'helper/axios'
import { getCookie, setCookie } from 'helper/cookie'
import HeaderComponents from 'components/Layouts/Header/header-new.components'
import SliderComponent from 'components/Layouts/Slider/slider.components'
import HomePage from 'pages/ProjectList/index'
import ProjectListV2Page from 'pages/ProjectListV2/index'
import LoginPage from 'pages/Login/index'
import CreateProject from 'pages/Project/index'
import ColorList from '../src/constants/color.constants'
import { ContainerHeader, LayoutContainer, MarginDisplay } from './App.styles'
import Taskinbox from 'components/TaskBox/TaskInbox'
import Taskinboxdetail from 'components/TaskBox/Taskinboxdetail'
import ProfessionSkills from 'components/ProfessionSkills/professionskills'
import OverviewMain from 'components/Overviews/OverviewMain'
import NoPermission from 'common/nopermission'
import ManagementFunctional from 'components/Management/Management'
import myprofile from 'components/Myprofile/myprofile'
import activity from 'components/Activity/activity'
import ProjectFile from 'components/Overviews/components/ProjectFile'
import { CounterProvider } from 'redux/Golbalvalues'
import SummaryMainComponents from 'components/Summary/summarymain'
import HistoryInbox from 'components/TaskBox/History'
import Reschedule from 'components/Reschedule/reschedule'
import Forgotpassword from 'components/Login/login.forgot'
import Resetpassword from 'components/Login/login.resetpw'
import AnalyticsComponent from 'components/DataAnalytics/analytics'
import { verifyLandingLoginFormAxons } from 'redux/user/user.action'
import ForgotInternalComponent from 'components/Login/login.forgot.internal'
import QuickUpdateMain from 'components/QuickUpdate/QuickUpdateMain'
import CreateProjectMain from 'components/CreateProject/CreateProjectMain'
import EditProjectMain from 'components/CreateProject/EditProjectMain'
import HelpdeskPage from 'pages/HelpDesk'
import VersionPage from 'pages/Version'
import { REACT_APP_REFINER_PROJECT_ID, LOGIN_AXONS_ONE } from 'config/env'

const { Content } = Layout
const Footer = styled.div``
export const StyledRoute = styled(Route)`
  flex-grow: 1;
`

const initialState = {
  collapsed: false,
}
const App = () => {
  const dispatch = useDispatch()
  const checkMobileView = isMobile
  dispatch(isMobileAction(checkMobileView))
  const isMobielView = useSelector((state) => get(state, 'device.isMobileView', false))
  const authorization = useSelector((state) => get(state, 'user.auth', ''))
  const token = getCookie('access_token_admin')
  const [collapsed, setCollapsed] = useState(initialState.collapsed)
  const [marginStyle, setMarginStyle] = useState(264)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false)
  const dataVersion = '1.42.0'

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [])

  const forceClose = useCallback(() => setCollapsed(true), [])
  const forceOpen = useCallback(() => setCollapsed(false), [])

  const useMargin = useCallback((getstate, isCollapsed) => {
    setMarginStyle(getstate)
    setSidebarCollapsed(isCollapsed)
  }, [])
  setCookie('lang', 'en')
  let uri = window.location.pathname
  let enc = encodeURI(uri)
  let redir = ''
  if (enc !== '/login' && enc !== '/v2/login' && enc !== '/reset') {
    redir = '?rd=' + enc
  }

  React.useEffect(() => {
    var url_landing = window.location.href.split('login?code=')
    const thisKeyVerify = url_landing[1]

    if (thisKeyVerify) {
      dispatch(verifyLandingLoginFormAxons(thisKeyVerify))
      return
    }
  }, [])

  // Set Refiner Project ID
  React.useEffect(() => {
    _refiner('setProject', REACT_APP_REFINER_PROJECT_ID)
  }, [])

  // Identify user to Refiner
  React.useEffect(() => {
    if (!authorization) return

    const userId = getCookie('userID')
    const rawInfoUser = getCookie('infoUser')
    let email = ''
    try {
      const infoUser = JSON.parse(rawInfoUser)
      email = infoUser?.email || ''
    } catch (_) {}

    if (userId || email) {
      _refiner('identifyUser', {
        id: userId,
        email,
      })
    }
  }, [authorization])

  const checkAuth = () => {
    if (token || authorization) {
      var url_string = window.location.href //window.location.href
      var url = new URL(url_string)
      var urlSearch = url.searchParams.get('rd')
      if (urlSearch !== null) {
        window.location.href = urlSearch
      } else {
        return (
          <CounterProvider>
            <Router>
              <ContainerHeader className="ContainerHeader">
                <LayoutContainer className="Layoutcontainer">
                  <HeaderComponents
                    isMobielView={isMobielView}
                    isTablet={isTablet}
                    collapsed={collapsed}
                    toggle={toggle}
                  />
                  <Layout
                    className="LayoutMasterWebsite"
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      marginTop: 56,
                      height: '100%',
                    }}
                  >
                    <SliderComponent
                      trigger={null}
                      collapsed={collapsed}
                      isMobielView={isMobielView}
                      isTablet={isTablet}
                      toggle={toggle}
                      useMargin={useMargin}
                      onAutoClose={forceClose}
                      onAutoOpen={forceOpen}
                    />
                    <MarginDisplay
                      className="marginDisplay"
                      style={{
                        paddingLeft: marginStyle,
                      }}
                    >
                      <Content
                        style={{
                          maxWidth: sidebarCollapsed && !isMobielView ? 'none' : 1320,
                          width: sidebarCollapsed && !isMobielView ? '100%' : 'auto',
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                          paddingRight: sidebarCollapsed && !isMobielView ? '28px' : '0',
                        }}
                        className="contentlazy"
                      >
                        <div>
                          <Switch>
                            <StyledRoute
                              exact
                              path="/project/:id/quick-update"
                              component={QuickUpdateMain}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/edit"
                              component={EditProjectMain}
                            />
                            <StyledRoute exact path="/" component={HomePage} />
                            <StyledRoute
                              exact
                              path="/project-list"
                              component={HomePage}
                            />
                            <StyledRoute
                              exact
                              path="/project-list-v2"
                              component={ProjectListV2Page}
                            />
                            <StyledRoute
                              exact
                              path="/create-project"
                              component={CreateProjectMain}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/:slug"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/:slug/:idchart"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/:slug/:idchart/:slug2"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/:slug/:idchart/:slug2/:idsubtask"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/project/:id/:slug/:idchart/:slug2/:idsubtask/:slug3"
                              component={CreateProject}
                            />
                            <StyledRoute
                              exact
                              path="/overview/:id"
                              component={OverviewMain}
                            />
                            <StyledRoute
                              exact
                              path="/dashboard"
                              component={SummaryMainComponents}
                            />
                            <StyledRoute
                              exact
                              path="/overview/:id/projectfile"
                              component={ProjectFile}
                            />
                            <StyledRoute
                              exact
                              path="/historyInbox"
                              component={HistoryInbox}
                            />
                            <StyledRoute exact path="/taskInBox" component={Taskinbox} />
                            <StyledRoute exact path="/myprofile" component={myprofile} />
                            <StyledRoute exact path="/activity" component={activity} />
                            <StyledRoute
                              exact
                              path="/reschedule/:id"
                              component={Reschedule}
                            />
                            <StyledRoute
                              exact
                              path="/activity/:id"
                              component={activity}
                            />
                            <StyledRoute
                              exact
                              path="/Taskinboxdetail"
                              component={Taskinboxdetail}
                            />
                            <StyledRoute
                              exact
                              path="/taskinbox/:project_id/:subtaskId"
                              component={Taskinboxdetail}
                            />
                            <StyledRoute
                              exact
                              path="/taskinbox/:project_id/:subtaskId/:slug"
                              component={Taskinboxdetail}
                            />
                            {/* @@ newpath */}
                            <StyledRoute
                              exact
                              path="/historyInbox/:project_id/:subtaskId"
                              component={Taskinboxdetail}
                            />
                            <StyledRoute
                              exact
                              path="/historyInbox/:project_id/:subtaskId/:slug"
                              component={Taskinboxdetail}
                            />
                            {/* @@ newpath */}
                            <StyledRoute
                              exact
                              path="/professional-skills"
                              component={ProfessionSkills}
                            />
                            <StyledRoute
                              exact
                              path="/data-analytics"
                              component={AnalyticsComponent}
                            />

                            <StyledRoute
                              exact
                              path="/management"
                              component={ManagementFunctional}
                            />

                            <StyledRoute
                              exact
                              path="/management/:slug"
                              component={ManagementFunctional}
                            />

                            <StyledRoute
                              exact
                              path="/helpdesk"
                              component={HelpdeskPage}
                            />

                            <StyledRoute
                              exact
                              path="/no-permission"
                              component={NoPermission}
                            />

                            <Redirect exact strict to="/" />
                          </Switch>
                        </div>
                        <Footer
                          className="web-main-footer"
                          style={{
                            color: ColorList.darkgray,
                            marginTop: '32px',
                            borderTop: '1px solid rgb(233, 233, 233)',
                            marginBottom: '20px',
                          }}
                        >
                          <Row style={{ width: '100%' }}>
                            <Col style={{ width: '50%', textAlign: 'center' }}>
                              Version {dataVersion}
                            </Col>
                            <Col style={{ width: '50%', textAlign: 'center' }}>
                              © 2022 AXONS. All Rights Reserved.
                            </Col>
                          </Row>
                        </Footer>
                      </Content>
                    </MarginDisplay>
                  </Layout>
                </LayoutContainer>
              </ContainerHeader>
            </Router>
          </CounterProvider>
        )
      }
    }

    return (
      <div className="Layout-login">
        <Switch>
          {LOGIN_AXONS_ONE ? (
            <Route
              exact
              path="/login"
              render={() => {
                window.location.replace('/v2/login')
                return null
              }}
            />
          ) : (
            <Route exact path="/login" component={LoginPage} />
          )}
          <Route exact path="/login/forgot" component={Forgotpassword} />
          <Route exact path="/login/forgotinternal" component={ForgotInternalComponent} />
          <Route exact path="/reset/:slug" component={Resetpassword} />

          <Redirect
            to={{
              pathname: '/login',
              search: redir,
            }}
          />
        </Switch>
        <Footer
          className="web-main-footer"
          style={{
            textAlign: 'center',
            color: ColorList.darkgray,
          }}
        >
          <Row style={{ width: '100%' }}>
            <Col style={{ width: '50%' }}>Version {dataVersion}</Col>
            <Col style={{ width: '50%' }}>© 2022 AXONS. All Rights Reserved.</Col>
          </Row>
        </Footer>
      </div>
    )
  }

  return (
    <Router>
      <Switch>
        <Route exact path="/version" component={VersionPage} />
        <Route>{checkAuth()}</Route>
      </Switch>
    </Router>
  )
}

export default App
